<template>
  <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab-2">

    <div class="form-row">
      <div class="col-md-12">
        <div class="innerbox">
          <h2>Fotodokumentation</h2>
          <div class="inrbox formlft">
            <form>
              <div class="form-row mb-3">
                <label  class="col-sm-2">Tagesdokumentation</label>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
                        <input class="radio-side" id="Aktiviert22" type="radio" v-model="project.dailydocu"  name="status" value="0">
                      <label class="side-lable" for="Aktiviert22">Individuell</label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <input class="radio-side" id="Aktiviert" type="radio" v-model="project.dailydocu" name="status" value="1">
                      <label for="Aktiviert" class="side-lable">Alle Tagesfotos immer zur Tagesdoku</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row mb-3">
                <label class="col-sm-2">Fotoqualität</label>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <input class="radio-side" v-model="project.photoquality"  id="inputEmail344" type="radio" name="status1" value="0">
                      <label for="inputEmail344" class="side-lable">Originalgröße - Fotos immer in Originalgröße hochladen</label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <input class="radio-side" v-model="project.photoquality" type="radio" id="Aktiviert3333" name="status1" value="1">
                      <label for="Aktiviert3333"  class="side-lable">Verkleinert - Fotos immer verkleinern, um die Uploadzeit zu verkürzen</label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <input id="Aktiviert2111" class="radio-side" v-model="project.photoquality" type="radio" name="status1" value="2">
                      <label for="Aktiviert2111" class="side-lable">Individuell - Beim hochladen nachfragen, ob original oder verkleinern</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <label class="col-sm-2">GPS Funktionalität verwenden</label>
                <div class="col-sm-6">
                  <div class="switch new">
                    <label class="w-100">
                      <input type="checkbox" v-model="project.use_gps">
                      <span class="lever mr-0"></span>
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="dokubtns text-right">
            <span class="btninner">
              <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$router.push({name: 'photo', params: {id: $route.params.id}})">
                Abbrechen
              </button>
              <button type="button" class="btn btn-blue" @click="saveProjectDetails">
                Speichern
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'photoDocumentation',
  data(){
    return {}
  },
  computed : {
    project(){
      return this.$store.state.appSettings.project
    },

  },
  methods: {
    async saveProjectDetails(){
      await this.$store.dispatch('updateProjectDetails');
      await this.$router.push({name: 'photo', params: {id: this.$route.params.id}});
    },
  }
}
</script>

<style scoped>
.side-lable{
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/PhotoDocumentation.vue